import { IoIosArrowBack, IoIosArrowForward } from "react-icons/io";

const ImageCarousel = ({ images, currentIndex, setCurrentIndex }) => {
  if (!images || images.length === 0) {
    return (
      <div className="placeholder-image">
        <span>Images</span>
      </div>
    );
  }
  return (
    <div className="carousel">
      <button
        className="carousel-btn prev"
        aria-label="Previous image"
        onClick={() =>
          setCurrentIndex((idx) => (idx <= 0 ? images.length - 1 : idx - 1))
        }
      >
        <IoIosArrowBack />
      </button>
      <img
        src={images[currentIndex]}
        alt={`item ${currentIndex + 1}`}
        className="item-image"
      />
      <button
        className="carousel-btn next"
        aria-label="Next image"
        onClick={() =>
          setCurrentIndex((idx) => (idx >= images.length - 1 ? 0 : idx + 1))
        }
      >
        <IoIosArrowForward />
      </button>
      <div className="carousel-dots">
        {images.map((_, i) => (
          <button
            key={i}
            className={`dot ${i === currentIndex ? "active" : ""}`}
            onClick={() => setCurrentIndex(i)}
            aria-label={`Show image ${i + 1}`}
          />
        ))}
      </div>
    </div>
  );
};
export default ImageCarousel;
